import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { buildSelectorsContext } from "./modules/selectors.js";
import { initMenu } from "./modules/menu.js";
import { initHeroAnimation } from "./modules/hero.js";
import { initEcoSlider } from "./modules/ecoSlider.js";
import { initBlogSlider } from "./modules/blogSlider.js";
import { initHistorySlider } from "./modules/historySlider.js";
import { initLenis } from "./modules/lenis.js";
import { initScrollAnimations } from "./modules/scrollAnimations.js";
import { initEcommerceScroll } from "./modules/ecommerceScroll.js";
import { initLocatorMap } from "./modules/locatorMap.js";
import { initCategoryFilters } from "./modules/categoryFilters.js";
import { initSingleProductSlider } from "./modules/singleProductSlider.js";
import { initEstampasSlider } from "./modules/estampasSlider.js";
import { initColorVariations } from "./modules/colorVariations.js";
import { initSolucoesFormularioPin } from "./modules/solucoesFormularioPin.js";
import { initSegundaViaBoleto } from "./modules/segundaViaBoleto.js";
import { initBlogPage } from "./modules/blogPage.js";
import { initShowroomModal } from "./modules/showroomModal.js";

gsap.registerPlugin(ScrollTrigger);

const isClient = typeof window !== "undefined";
const isScrollTriggerDebug =
  isClient && Boolean(window.__DEBUG_SCROLLTRIGGER__);

const logScrollTriggerState = () => {
  if (!isScrollTriggerDebug) {
    return;
  }

  const triggers = ScrollTrigger.getAll();
  console.groupCollapsed?.("[ScrollTrigger Debug]");
  console.log("ScrollTrigger count:", triggers.length);
  console.log(
    "Registered triggers:",
    triggers.map((trigger) => trigger.vars.trigger),
  );
  console.groupEnd?.();
};

const registerDebugMarkers = (ctx) => {
  if (!isScrollTriggerDebug) {
    return;
  }

  const debugTargets = [
    ctx.heroTitleLines[0],
    ctx.heroSubtitle,
    ctx.heroProducts[0],
  ].filter(Boolean);

  debugTargets.slice(0, 2).forEach((target, index) => {
    ScrollTrigger.create({
      trigger: target,
      start: "top center",
      end: "bottom center",
      markers: true,
      id: `debug-marker-${index}`,
    });
  });
};

export function initApp() {
  const ctx = buildSelectorsContext();

  initLenis(ctx);
  initMenu(ctx);
  initHeroAnimation(ctx);
  initEcoSlider(ctx);
  initBlogSlider(ctx);
  initHistorySlider(ctx);
  initSingleProductSlider();
  initEstampasSlider();
  initColorVariations();
  initEcommerceScroll(ctx);
  initSolucoesFormularioPin();
  initSegundaViaBoleto();
  initScrollAnimations(ctx);
  initLocatorMap();
  initCategoryFilters();
  initShowroomModal();

  registerDebugMarkers(ctx);
  ScrollTrigger.refresh();
  logScrollTriggerState();

  initBlogPage(ctx);

  window.__appCtx = ctx;
  return ctx;
}
